import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import LinearProgress from '@material-ui/core/LinearProgress';
import Typography from '@material-ui/core/Typography';
import FieldText from '@react-form-fields/material-ui/components/Text';
import { theme } from 'assets/theme';
import { FormComponent, IStateForm } from 'components/Abstract/Form';
import ErrorMessage from 'components/Shared/ErrorMessage';
import Snackbar from 'components/Shared/Snackbar';
import { WithStyles } from 'decorators/withStyles';
import { IDocument } from 'interfaces/document';
import { IFile } from 'interfaces/file';
import React from 'react';
import RxOp from 'rxjs-operators';
import fileService from 'services/file';
import DocumentFileReader from 'components/Shared/FileSelector/FileReader';

/* eslint-disable max-lines */
interface IState extends IStateForm<IFile> {
  loading: boolean;
  error?: string;
  file?: File;
  selectorOpened: boolean;
  model: any;
}

interface IProps {
  opened: boolean;
  document: IDocument;
  onComplete: (file: IFile) => void;
  onCancel: () => void;
  classes?: any;
}

@WithStyles({
  dialog: {
    width: 1700,
    height: 700,
    maxWidth: '100vw',
  },
  root: {
    maxWidth: '100vw',
  },
  Fragment: {
    marginBottom: 20,
    maxWidth: '100vw',
  },
  img: {
    maxWidth: '100%',
    margin: 'auto',
    display: 'block',
    padding: 5,
    boxShadow: theme.shadows['5']
  },
  cardActions: {
    justifyContent: 'flex-end'
  },
  textField: {
    margin: 8
  },
  heading: {
    marginTop: 30,
    marginBottom: 20
  },
  ImageSelector: {
    marginTop: 30
  },
  formControl: {
    margin: theme.spacing(1),
    minWidth: 200,
    maxWidth: '100vw',
  },
  Card: {
    marginTop: 30,
    maxWidth: '100vw',
  },
  Paper: {
    width: 600,
    height: 500,
    maxWidth: '100vw',
  },
  content: {
    padding: theme.spacing(2)
  }
})

export default class FileUploadDialog extends FormComponent<IProps, IState> {
  fileUploadFormRef = React.createRef<HTMLFormElement>();
  state = {
    selectorOpened: true,
    loading: false,
    file: null as File,
    error: null as string,
    model: {} as any,
  };

  handleEnter = () => {
    const { document } = this.props;
    const model = {
      frequency: document.frequency,
      criticality: document.criticality,
      documentId: document.id,
      expirationDate: new Date('2099-12-31T00:00:00'),
    };
    this.setState({ model });
  }

  onSubmit = (event: React.FormEvent) => {
    event.preventDefault();
    const { file, model } = this.state;
    if (!file) return this.setState({ error: 'Necessário selecionar um arquivo' });

    this.setState({ loading: true });

    fileService.save({ ...model, file }).pipe(
      RxOp.logError(),
      RxOp.bindComponent(this)
    ).subscribe(next => {
      if (!next.response) return;

      this.setState({ loading: false, file: null });

      Snackbar.show(`${file.name} foi salvo com sucesso!`);
      return this.props.onComplete(next.response as IFile);
    }, err => {
      Snackbar.error(`Falha ao salvar o arquivo ${file.name}: ${err}`);
      this.setState({ loading: false });
    });
  }

  selectFile = () => this.setState({ selectorOpened: true });

  closeFileSelector = (filename: File) => {
    this.setState({ file: filename, selectorOpened: false, error: null });
  }

  render() {
    const { loading, error, file } = this.state;
    const { opened, classes, onCancel } = this.props;

    return (
      <Dialog
        open={opened}
        disableBackdropClick
        disableEscapeKeyDown
        onEnter={this.handleEnter}
        fullWidth
        maxWidth='sm'
      >
        {loading && <LinearProgress color='secondary' />}

        <form onSubmit={this.onSubmit} ref={this.fileUploadFormRef}>
          <DialogTitle>Novo arquivo</DialogTitle>
          <DialogContent className={classes.content}>
            <Typography component='div' dir={theme.direction}>
              <DocumentFileReader droppable fileSelected={this.closeFileSelector} />
              <FieldText
                disabled
                label="Arquivo"
                name="filename"
                value={file ? file.name : ''}
                onChange={() => { }}
                validation='required|string'
              />
              {error && <ErrorMessage error={error} />}
            </Typography>
          </DialogContent>
          <DialogActions className={classes.content}>
            <Button onClick={onCancel}>
              Cancelar
            </Button>
            <Button color='primary' variant={'contained'} type='submit' disabled={loading || !!error}>
              Salvar
            </Button>
          </DialogActions>
        </form>
      </Dialog>
    );
  }
}